import { FC } from 'react';
import { BordOneToneIcon } from 'components/NudosComponents';
import './BannerColorSelector.scss';

export interface IBannerColor {
  id: string;
  color: string;
  label?: string;
}

interface IBannerColorSelectorProps {
  selectedColorId?: string | null;
  onColorSelect: (colorId: string | null) => void;
  colors: IBannerColor[];
  isDisabled?: boolean;
}

/**
 * Componente para seleccionar el color del banner
 * @param selectedColorId - ID del color actualmente seleccionado
 * @param onColorSelect - Función que se ejecuta al seleccionar un color
 * @param colors - Array de colores disponibles para seleccionar
 * @param isDisabled - Indica si el selector está deshabilitado
 */
export const BannerColorSelector: FC<IBannerColorSelectorProps> = ({
  selectedColorId,
  onColorSelect,
  colors,
  isDisabled = false
}) => {
  const handleColorClick = (colorId: string | null) => {
    if (!colorId || isDisabled) return;
    onColorSelect(colorId);
  };

  return (
    <div className={`bannerColorSelector ${isDisabled ? 'disabled' : ''}`}>
      <label className="bannerColorSelectorLabel">Color del banner</label>
      <div className="bannerColorSelectorOptions">
        {colors.map(color => {
          const isSelected = selectedColorId === color.id;
          return (
            <button
              key={color.id}
              type="button"
              className={`bannerColorOption ${isSelected ? 'selected' : ''}`}
              style={{ backgroundColor: color.color }}
              onClick={() => handleColorClick(color.id)}
              disabled={isDisabled}
              aria-label={color.label || `Color ${color.id}`}
            >
              {isSelected && (
                <BordOneToneIcon
                  variant="check"
                  stroke="black"
                  standardSize={20}
                  className="bannerColorCheckIcon"
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BannerColorSelector;
